import React from 'react';
import { useLanguage } from '../utils/i18n';

export default function ConfirmModal({ isOpen, title, message, onConfirm, onCancel }) {
    const { t } = useLanguage();

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" style={{ zIndex: 2000 }}>
            <div className="modal glass-card animate-zoom" style={{ maxWidth: 400, textAlign: 'center' }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>❓</div>
                <h2 style={{ fontSize: 22, fontWeight: 700, color: '#fff', marginBottom: 12 }}>{title}</h2>
                <p style={{ color: 'var(--text-muted)', fontSize: 15, marginBottom: 32, lineHeight: 1.6 }}>
                    {message}
                </p>
                <div style={{ display: 'flex', gap: 12 }}>
                    <button
                        type="button"
                        className="btn btn-outline"
                        onClick={onCancel}
                        style={{ flex: 1, justifyContent: 'center' }}
                    >
                        {t('cancel')}
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger btn-glow"
                        onClick={onConfirm}
                        style={{ flex: 1, justifyContent: 'center', background: 'var(--danger)' }}
                    >
                        {t('confirm_action')}
                    </button>
                </div>
            </div>
        </div>
    );
}
